<section class="group-block">
  <button
    type="button"
    class="group-button"
    [class.not-implemented]="group.implemented !== true"
    [class.disabled]="group.disabled === true"
    [class.expanded]="expanded"
    [attr.aria-expanded]="expanded"
    (click)="toggled.emit()"
  >
    <span>{{ group.label }}</span>
    <span class="chevron" aria-hidden="true">▾</span>
  </button>

  <div class="submenu-wrap" [class.expanded]="expanded">
    <nav class="submenu">
      @for (item of group.items; track item.label) {
        <app-vertical-menu-item [item]="item" [activePath]="activePath"></app-vertical-menu-item>
      }
    </nav>
  </div>
</section>
